var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 980.45331,
    height: 543.37335,
    viewBox: "0 0 980.45331 543.37335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,543.37333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311.39,1664.42 C 832.043,1500.25 479.398,1473.39 398.32,1616.1 c -75.136,132.29 96.223,386.83 429.332,684.23 l -132.789,77.19 C 286.438,2017.69 67.3477,1717.49 159.434,1555.37 261.852,1375.1 714.246,1426.95 1323.71,1647.59 l -12.32,16.83",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1311.39,1664.42 C 832.043,1500.25 479.398,1473.39 398.32,1616.1 c -75.136,132.29 96.223,386.83 429.332,684.23 l -132.789,77.19 C 286.438,2017.69 67.3477,1717.49 159.434,1555.37 261.852,1375.1 714.246,1426.95 1323.71,1647.59 Z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2665.34,3627.16 c 883.08,409.85 1598.38,568.11 1730.76,335.04 143.17,-251.98 -454.71,-856.92 -1376.23,-1449 l -14.06,10.42 c 748.36,495.28 1218.55,995.7 1102.44,1200.1 -103.21,181.68 -648.58,92.08 -1335.24,-205.76 l -107.67,109.2",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2665.34,3627.16 c 883.08,409.85 1598.38,568.11 1730.76,335.04 143.17,-251.98 -454.71,-856.92 -1376.23,-1449 l -14.06,10.42 c 748.36,495.28 1218.55,995.7 1102.44,1200.1 -103.21,181.68 -648.58,92.08 -1335.24,-205.76 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1532.62,2219.82 c -693.362,0 -1255.452,385.21 -1255.452,860.36 0,475.18 562.09,860.39 1255.452,860.39 693.36,0 1255.47,-385.21 1255.47,-860.39 0,-475.15 -562.11,-860.36 -1255.47,-860.36 z m 0,1808.56 C 688.953,4028.38 5,3603.86 5,3080.18 c 0,-523.65 683.953,-948.17 1527.62,-948.17 843.68,0 1527.6,424.52 1527.6,948.17 0,523.68 -683.92,948.2 -1527.6,948.2",
    style: {
      fill: "#ed192d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1532.62,2219.82 c -693.362,0 -1255.452,385.21 -1255.452,860.36 0,475.18 562.09,860.39 1255.452,860.39 693.36,0 1255.47,-385.21 1255.47,-860.39 0,-475.15 -562.11,-860.36 -1255.47,-860.36 z m 0,1808.56 C 688.953,4028.38 5,3603.86 5,3080.18 c 0,-523.65 683.953,-948.17 1527.62,-948.17 843.68,0 1527.6,424.52 1527.6,948.17 0,523.68 -683.92,948.2 -1527.6,948.2 z",
    style: {
      fill: "none",
      stroke: "#ed192d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2035.47,2828.76 155.19,571.13 161.42,-571.13 z m -744.96,0 155.2,571.13 161.41,-571.13 z m -741.854,0 155.199,571.13 161.411,-571.13 z m 1828.254,912.57 -201.76,102.43 -276.25,-1015 -332.13,1136.08 h -96.23 L 1160.15,2828.76 868.367,3831.37 663.508,3722.71 384.148,2704.63 l 96.223,-127.3 37.246,133.47 h 375.582 l 117.951,-434.53 121.06,-27.93 130.36,462.46 h 378.69 l 139.68,-496.63 279.36,65.18 -90.02,310.4 31.04,121.05 h 378.69 l 68.29,-238.98 239,207.95 -310.39,1061.56",
    style: {
      fill: "#ed192d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2035.47,2828.76 155.19,571.13 161.42,-571.13 z m -744.96,0 155.2,571.13 161.41,-571.13 z m -741.854,0 155.199,571.13 161.411,-571.13 z m 1828.254,912.57 -201.76,102.43 -276.25,-1015 -332.13,1136.08 h -96.23 L 1160.15,2828.76 868.367,3831.37 663.508,3722.71 384.148,2704.63 l 96.223,-127.3 37.246,133.47 h 375.582 l 117.951,-434.53 121.06,-27.93 130.36,462.46 h 378.69 l 139.68,-496.63 279.36,65.18 -90.02,310.4 31.04,121.05 h 378.69 l 68.29,-238.98 239,207.95 z",
    style: {
      fill: "none",
      stroke: "#ed192d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1654.16,1833.05 h 130.4 l -116.43,-547.53 h 255.16 l -22.34,-102.44 h -384.6 l 137.81,649.97",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1654.16,1833.05 h 130.4 l -116.43,-547.53 h 255.16 l -22.34,-102.44 h -384.6 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2114.18,1869.38 h 124.79 l -26.09,-119.18 h -124.76 z m -45.63,-206.73 h 124.78 L 2090.9,1183.08 h -124.79 l 102.44,479.57",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2114.18,1869.38 h 124.79 l -26.09,-119.18 h -124.76 z m -45.63,-206.73 h 124.78 L 2090.9,1183.08 h -124.79 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2337.67,1571.39 h -96.85 l 19.57,91.26 h 96.83 c 25.14,122.01 66.12,230.01 211.38,230.01 28.89,0 56.82,-5.57 77.31,-12.1 l -28.88,-93.12 c -11.18,5.59 -25.15,8.37 -38.17,8.37 -68.91,0 -84.75,-82.87 -96.85,-133.16 h 111.74 l -19.55,-91.26 h -111.74 l -81.96,-388.31 h -124.77 l 81.94,388.31",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2337.67,1571.39 h -96.85 l 19.57,91.26 h 96.83 c 25.14,122.01 66.12,230.01 211.38,230.01 28.89,0 56.82,-5.57 77.31,-12.1 l -28.88,-93.12 c -11.18,5.59 -25.15,8.37 -38.17,8.37 -68.91,0 -84.75,-82.87 -96.85,-133.16 h 111.74 l -19.55,-91.26 h -111.74 l -81.96,-388.31 h -124.77 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2916.88,1469.89 c 1.85,11.17 2.79,21.44 2.79,32.59 0,51.22 -27.01,80.11 -79.15,80.11 -77.29,0 -110.83,-46.57 -135.03,-112.7 z m -228.14,-85.67 c 0,-88.46 47.48,-121.06 133.15,-121.06 51.22,0 100.57,13.05 147.13,34.46 l -15.84,-98.7 c -48.42,-14.92 -101.48,-27.01 -152.7,-27.01 -137.83,0 -230.96,67.05 -230.96,209.51 0,149 115.48,292.41 272.86,292.41 118.25,0 196.48,-60.53 196.48,-182.5 0,-36.32 -4.66,-71.71 -12.11,-107.11 h -338.01",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2916.88,1469.89 c 1.85,11.17 2.79,21.44 2.79,32.59 0,51.22 -27.01,80.11 -79.15,80.11 -77.29,0 -110.83,-46.57 -135.03,-112.7 z m -228.14,-85.67 c 0,-88.46 47.48,-121.06 133.15,-121.06 51.22,0 100.57,13.05 147.13,34.46 l -15.84,-98.7 c -48.42,-14.92 -101.48,-27.01 -152.7,-27.01 -137.83,0 -230.96,67.05 -230.96,209.51 0,149 115.48,292.41 272.86,292.41 118.25,0 196.48,-60.53 196.48,-182.5 0,-36.32 -4.66,-71.71 -12.11,-107.11 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3441.14,1833.05 h 135.94 L 3440.2,1183.08 h -135.95 l 136.89,649.97",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3441.14,1833.05 h 135.94 L 3440.2,1183.08 h -135.95 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3641.35,1593.76 c 5.57,28.86 10.23,54 12.1,68.89 h 121.97 l -8.36,-46.55 h 1.86 c 34.43,31.66 81.94,57.73 135.96,57.73 94.02,0 156.42,-58.67 156.42,-153.64 0,-36.33 -9.3,-74.51 -15.83,-104.3 l -50.27,-232.81 h -124.79 l 46.56,226.28 c 6.52,32.59 13.96,65.19 13.96,100.59 0,40.04 -27.94,67.02 -67.97,67.02 -86.59,0 -118.26,-80.99 -134.1,-152.69 l -51.21,-241.2 h -124.76 l 88.46,410.68",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3641.35,1593.76 c 5.57,28.86 10.23,54 12.1,68.89 h 121.97 l -8.36,-46.55 h 1.86 c 34.43,31.66 81.94,57.73 135.96,57.73 94.02,0 156.42,-58.67 156.42,-153.64 0,-36.33 -9.3,-74.51 -15.83,-104.3 l -50.27,-232.81 h -124.79 l 46.56,226.28 c 6.52,32.59 13.96,65.19 13.96,100.59 0,40.04 -27.94,67.02 -67.97,67.02 -86.59,0 -118.26,-80.99 -134.1,-152.69 l -51.21,-241.2 h -124.76 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4472.9,1560.22 c -32.59,12.1 -67.06,22.37 -102.43,22.37 -37.25,0 -83.81,-10.27 -83.81,-48.44 0,-60.53 162.01,-82.89 162.01,-200.21 0,-124.78 -108.95,-162.03 -216.04,-162.03 -50.27,0 -100.56,7.44 -146.18,28.88 l 26.99,99.62 c 35.38,-19.55 70.78,-37.25 119.19,-37.25 41.91,0 85.68,13.97 85.68,53.08 0,77.29 -162.02,84.75 -162.02,204.87 0,112.69 108.94,152.72 207.66,152.72 45.63,0 92.19,-8.39 135.94,-19.54 l -26.99,-94.07",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4472.9,1560.22 c -32.59,12.1 -67.06,22.37 -102.43,22.37 -37.25,0 -83.81,-10.27 -83.81,-48.44 0,-60.53 162.01,-82.89 162.01,-200.21 0,-124.78 -108.95,-162.03 -216.04,-162.03 -50.27,0 -100.56,7.44 -146.18,28.88 l 26.99,99.62 c 35.38,-19.55 70.78,-37.25 119.19,-37.25 41.91,0 85.68,13.97 85.68,53.08 0,77.29 -162.02,84.75 -162.02,204.87 0,112.69 108.94,152.72 207.66,152.72 45.63,0 92.19,-8.39 135.94,-19.54 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4958.04,1252 c -5.59,-28.88 -10.26,-54.02 -12.13,-68.92 h -121.97 l 8.39,46.57 h -1.87 c -34.46,-31.67 -81.94,-57.74 -135.96,-57.74 -94.05,0 -156.44,58.66 -156.44,153.64 0,36.33 9.31,74.51 15.83,104.3 l 50.28,232.8 h 124.79 l -46.57,-226.28 c -6.53,-32.58 -13.97,-65.18 -13.97,-100.56 0,-40.05 27.94,-67.04 67.98,-67.04 86.62,0 118.27,81 134.1,152.7 l 51.21,241.18 H 5046.5 L 4958.04,1252",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4958.04,1252 c -5.59,-28.88 -10.26,-54.02 -12.13,-68.92 h -121.97 l 8.39,46.57 h -1.87 c -34.46,-31.67 -81.94,-57.74 -135.96,-57.74 -94.05,0 -156.44,58.66 -156.44,153.64 0,36.33 9.31,74.51 15.83,104.3 l 50.28,232.8 h 124.79 l -46.57,-226.28 c -6.53,-32.58 -13.97,-65.18 -13.97,-100.56 0,-40.05 27.94,-67.04 67.98,-67.04 86.62,0 118.27,81 134.1,152.7 l 51.21,241.18 h 124.79 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5147.99,1598.42 c 3.71,20.46 7.44,41.9 11.18,64.23 h 119.19 l -16.75,-90.33 h 1.83 c 22.37,52.17 83.82,101.51 141.55,101.51 15.84,0 32.59,-0.92 47.51,-4.66 l -26.1,-121.97 c -13.96,4.66 -31.64,7.45 -47.47,7.45 -88.47,0 -131.29,-79.16 -147.13,-156.47 l -44.7,-215.1 h -124.78 l 85.67,415.34",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5147.99,1598.42 c 3.71,20.46 7.44,41.9 11.18,64.23 h 119.19 l -16.75,-90.33 h 1.83 c 22.37,52.17 83.82,101.51 141.55,101.51 15.84,0 32.59,-0.92 47.51,-4.66 l -26.1,-121.97 c -13.96,4.66 -31.64,7.45 -47.47,7.45 -88.47,0 -131.29,-79.16 -147.13,-156.47 l -44.7,-215.1 h -124.78 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5593.1,1263.16 c 93.12,0 121.97,64.27 141.55,141.54 h -43.78 c -60.52,0 -161.09,-10.22 -161.09,-91.25 0,-33.51 31.64,-50.29 63.32,-50.29 z m 121.97,-6.49 h -1.86 c -42.82,-54.04 -85.66,-84.76 -154.57,-84.76 -86.59,0 -148.07,48.42 -148.07,136.89 0,158.31 176.93,170.4 294.28,170.4 h 43.76 c 3.71,13.05 3.71,27.02 3.71,40.99 0,48.42 -52.13,62.4 -95.91,62.4 -54.95,0 -108.01,-13.98 -157.38,-37.26 l 17.7,99.64 c 53.09,18.63 107.09,28.86 162.96,28.86 95.91,0 186.25,-35.38 186.25,-148.06 0,-64.25 -47.49,-252.35 -58.66,-342.69 h -105.22 l 13.01,73.59",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5593.1,1263.16 c 93.12,0 121.97,64.27 141.55,141.54 h -43.78 c -60.52,0 -161.09,-10.22 -161.09,-91.25 0,-33.51 31.64,-50.29 63.32,-50.29 z m 121.97,-6.49 h -1.86 c -42.82,-54.04 -85.66,-84.76 -154.57,-84.76 -86.59,0 -148.07,48.42 -148.07,136.89 0,158.31 176.93,170.4 294.28,170.4 h 43.76 c 3.71,13.05 3.71,27.02 3.71,40.99 0,48.42 -52.13,62.4 -95.91,62.4 -54.95,0 -108.01,-13.98 -157.38,-37.26 l 17.7,99.64 c 53.09,18.63 107.09,28.86 162.96,28.86 95.91,0 186.25,-35.38 186.25,-148.06 0,-64.25 -47.49,-252.35 -58.66,-342.69 h -105.22 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6002.83,1593.76 c 5.57,28.86 10.23,54 12.1,68.89 h 121.97 l -8.36,-46.55 h 1.87 c 34.43,31.66 81.93,57.73 135.94,57.73 94.05,0 156.44,-58.67 156.44,-153.64 0,-36.33 -9.32,-74.51 -15.84,-104.3 l -50.27,-232.81 h -124.79 l 46.55,226.28 c 6.53,32.59 13.98,65.19 13.98,100.59 0,40.04 -27.93,67.02 -67.97,67.02 -86.6,0 -118.27,-80.99 -134.11,-152.69 l -51.21,-241.2 h -124.77 l 88.47,410.68",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6002.83,1593.76 c 5.57,28.86 10.23,54 12.1,68.89 h 121.97 l -8.36,-46.55 h 1.87 c 34.43,31.66 81.93,57.73 135.94,57.73 94.05,0 156.44,-58.67 156.44,-153.64 0,-36.33 -9.32,-74.51 -15.84,-104.3 l -50.27,-232.81 h -124.79 l 46.55,226.28 c 6.53,32.59 13.98,65.19 13.98,100.59 0,40.04 -27.93,67.02 -67.97,67.02 -86.6,0 -118.27,-80.99 -134.11,-152.69 l -51.21,-241.2 h -124.77 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6865.1,1552.78 c -24.23,15.83 -56.82,24.19 -91.26,24.19 -99.64,0 -155.51,-93.11 -155.51,-183.44 0,-62.37 20.49,-124.76 106.15,-124.76 30.75,0 68.91,8.36 101.51,24.2 l -13.96,-98.7 c -38.19,-18.63 -79.16,-22.36 -120.14,-22.36 -123.85,0 -203.92,82.88 -203.92,206.73 0,167.61 110.79,295.19 283.06,295.19 46.57,0 91.28,-8.39 124.8,-18.62 l -30.73,-102.43",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6865.1,1552.78 c -24.23,15.83 -56.82,24.19 -91.26,24.19 -99.64,0 -155.51,-93.11 -155.51,-183.44 0,-62.37 20.49,-124.76 106.15,-124.76 30.75,0 68.91,8.36 101.51,24.2 l -13.96,-98.7 c -38.19,-18.63 -79.16,-22.36 -120.14,-22.36 -123.85,0 -203.92,82.88 -203.92,206.73 0,167.61 110.79,295.19 283.06,295.19 46.57,0 91.28,-8.39 124.8,-18.62 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7226.4,1469.89 c 1.85,11.17 2.78,21.44 2.78,32.59 0,51.22 -27,80.11 -79.14,80.11 -77.3,0 -110.83,-46.57 -135.03,-112.7 z m -228.17,-85.67 c 0,-88.46 47.52,-121.06 133.18,-121.06 51.22,0 100.57,13.05 147.13,34.46 l -15.84,-98.7 c -48.42,-14.92 -101.48,-27.01 -152.71,-27.01 -137.83,0 -230.94,67.05 -230.94,209.51 0,149 115.48,292.41 272.86,292.41 118.24,0 196.46,-60.53 196.46,-182.5 0,-36.32 -4.64,-71.71 -12.09,-107.11 h -338.05",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7226.4,1469.89 c 1.85,11.17 2.78,21.44 2.78,32.59 0,51.22 -27,80.11 -79.14,80.11 -77.3,0 -110.83,-46.57 -135.03,-112.7 z m -228.17,-85.67 c 0,-88.46 47.52,-121.06 133.18,-121.06 51.22,0 100.57,13.05 147.13,34.46 l -15.84,-98.7 c -48.42,-14.92 -101.48,-27.01 -152.71,-27.01 -137.83,0 -230.94,67.05 -230.94,209.51 0,149 115.48,292.41 272.86,292.41 118.24,0 196.46,-60.53 196.46,-182.5 0,-36.32 -4.64,-71.71 -12.09,-107.11 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2065.63,732.281 c -29.8,20.489 -79.15,38.168 -148.98,38.168 -144.34,0 -245.85,-108.961 -245.85,-261.66 0,-108.949 70.76,-205.801 185.31,-205.801 54.93,0 99.65,17.703 136.9,40.032 l -20.5,-124.758 c -47.5,-13.051 -97.77,-17.711 -147.12,-17.711 -196.5,0 -290.54,132.238 -290.54,308.238 0,209.531 142.47,364.102 372.48,364.102 65.18,0 134.08,-8.379 190.9,-31.653 l -32.6,-108.957",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2065.63,732.281 c -29.8,20.489 -79.15,38.168 -148.98,38.168 -144.34,0 -245.85,-108.961 -245.85,-261.66 0,-108.949 70.76,-205.801 185.31,-205.801 54.93,0 99.65,17.703 136.9,40.032 l -20.5,-124.758 c -47.5,-13.051 -97.77,-17.711 -147.12,-17.711 -196.5,0 -290.54,132.238 -290.54,308.238 0,209.531 142.47,364.102 372.48,364.102 65.18,0 134.08,-8.379 190.9,-31.653 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2437.17,491.09 c 0,62.39 -21.41,114.531 -94.99,114.531 -98.69,0 -148.04,-108.922 -148.04,-195.551 0,-63.3 26.07,-112.66 97.77,-112.66 96.83,0 145.26,111.738 145.26,193.68 z m 130.36,0.949 c 0,-168.57 -116.39,-291.488 -285.88,-291.488 -135.94,0 -217.88,83.808 -217.88,218.828 0,160.18 122.9,283.101 284.01,283.101 129.42,0 219.75,-78.23 219.75,-210.441",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2437.17,491.09 c 0,62.39 -21.41,114.531 -94.99,114.531 -98.69,0 -148.04,-108.922 -148.04,-195.551 0,-63.3 26.07,-112.66 97.77,-112.66 96.83,0 145.26,111.738 145.26,193.68 z m 130.36,0.949 c 0,-168.57 -116.39,-291.488 -285.88,-291.488 -135.94,0 -217.88,83.808 -217.88,218.828 0,160.18 122.9,283.101 284.01,283.101 129.42,0 219.75,-78.23 219.75,-210.441 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2670.89,638.211 c 3.73,18.629 7.44,38.199 10.23,53.09 h 116.42 l -11.17,-64.242 h 1.86 c 33.51,49.351 88.47,75.421 147.13,75.421 56.79,0 115.45,-33.519 121.97,-91.25 h 1.87 c 31.67,62.391 101.51,91.25 168.54,91.25 71.71,0 133.18,-58.652 133.18,-131.289 0,-42.851 -11.18,-91.269 -21.41,-130.39 l -50.3,-229.071 h -124.79 l 50.29,233.731 c 6.53,28.867 15.84,73.57 15.84,102.449 0,35.379 -27.01,57.711 -58.68,57.711 -86.6,0 -108.01,-100.562 -123.85,-165.75 L 2998.67,211.73 h -124.78 l 50.29,233.731 c 6.52,28.867 15.83,73.57 15.83,102.449 0,35.379 -27.01,57.711 -58.66,57.711 -84.75,0 -108.03,-101.48 -123.86,-165.75 L 2708.13,211.73 h -124.78 l 87.54,426.481",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2670.89,638.211 c 3.73,18.629 7.44,38.199 10.23,53.09 h 116.42 l -11.17,-64.242 h 1.86 c 33.51,49.351 88.47,75.421 147.13,75.421 56.79,0 115.45,-33.519 121.97,-91.25 h 1.87 c 31.67,62.391 101.51,91.25 168.54,91.25 71.71,0 133.18,-58.652 133.18,-131.289 0,-42.851 -11.18,-91.269 -21.41,-130.39 l -50.3,-229.071 h -124.79 l 50.29,233.731 c 6.53,28.867 15.84,73.57 15.84,102.449 0,35.379 -27.01,57.711 -58.68,57.711 -86.6,0 -108.01,-100.562 -123.85,-165.75 L 2998.67,211.73 h -124.78 l 50.29,233.731 c 6.52,28.867 15.83,73.57 15.83,102.449 0,35.379 -27.01,57.711 -58.66,57.711 -84.75,0 -108.03,-101.48 -123.86,-165.75 L 2708.13,211.73 h -124.78 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3700.78,605.621 c -84.73,0 -132.23,-111.742 -132.23,-195.551 0,-61.441 21.43,-112.66 81.96,-112.66 104.28,0 137.82,130.36 137.82,205.781 0,58.68 -29.81,102.43 -87.55,102.43 z m -218.83,23.277 c 4.66,23.293 8.39,41.911 10.26,62.403 h 118.24 l -13.97,-63.321 h 1.87 c 36.32,51.219 81.01,74.5 144.33,74.5 119.22,0 176.02,-81.019 176.02,-194.64 0,-149.899 -82.89,-307.289 -249.56,-307.289 -54.95,0 -111.74,18.629 -132.24,85.679 h -1.87 L 3480.08,16.1797 h -124.76 l 126.63,612.7183",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3700.78,605.621 c -84.73,0 -132.23,-111.742 -132.23,-195.551 0,-61.441 21.43,-112.66 81.96,-112.66 104.28,0 137.82,130.36 137.82,205.781 0,58.68 -29.81,102.43 -87.55,102.43 z m -218.83,23.277 c 4.66,23.293 8.39,41.911 10.26,62.403 h 118.24 l -13.97,-63.321 h 1.87 c 36.32,51.219 81.01,74.5 144.33,74.5 119.22,0 176.02,-81.019 176.02,-194.64 0,-149.899 -82.89,-307.289 -249.56,-307.289 -54.95,0 -111.74,18.629 -132.24,85.679 h -1.87 L 3480.08,16.1797 h -124.76 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4134.7,291.801 c 93.13,0 122.01,64.269 141.55,141.551 h -43.76 c -60.53,0 -161.1,-10.231 -161.1,-91.25 0,-33.524 31.67,-50.301 63.31,-50.301 z m 122.01,-6.492 h -1.87 c -42.82,-54.028 -85.67,-84.758 -154.59,-84.758 -86.59,0 -148.05,48.418 -148.05,136.89 0,158.309 176.93,170.399 294.25,170.399 h 43.77 c 3.74,13.058 3.74,27.019 3.74,41 0,48.41 -52.16,62.39 -95.92,62.39 -54.94,0 -108.03,-13.98 -157.37,-37.261 l 17.67,99.652 c 53.09,18.617 107.11,28.859 162.99,28.859 95.91,0 186.24,-35.378 186.24,-148.07 0,-64.238 -47.51,-252.351 -58.69,-342.68 h -105.21 l 13.04,73.579",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4134.7,291.801 c 93.13,0 122.01,64.269 141.55,141.551 h -43.76 c -60.53,0 -161.1,-10.231 -161.1,-91.25 0,-33.524 31.67,-50.301 63.31,-50.301 z m 122.01,-6.492 h -1.87 c -42.82,-54.028 -85.67,-84.758 -154.59,-84.758 -86.59,0 -148.05,48.418 -148.05,136.89 0,158.309 176.93,170.399 294.25,170.399 h 43.77 c 3.74,13.058 3.74,27.019 3.74,41 0,48.41 -52.16,62.39 -95.92,62.39 -54.94,0 -108.03,-13.98 -157.37,-37.261 l 17.67,99.652 c 53.09,18.617 107.11,28.859 162.99,28.859 95.91,0 186.24,-35.378 186.24,-148.07 0,-64.238 -47.51,-252.351 -58.69,-342.68 h -105.21 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4544.44,622.41 c 5.59,28.86 10.25,54 12.1,68.891 h 122 l -8.39,-46.563 h 1.87 c 34.45,31.672 81.93,57.742 135.96,57.742 94.05,0 156.44,-58.652 156.44,-153.64 0,-36.328 -9.31,-74.512 -15.84,-104.309 L 4898.3,211.73 h -124.78 l 46.56,226.282 c 6.53,32.578 13.98,65.179 13.98,100.578 0,40.051 -27.94,67.031 -67.98,67.031 -86.62,0 -118.27,-80.992 -134.1,-152.691 l -51.22,-241.2 h -124.79 l 88.47,410.68",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4544.44,622.41 c 5.59,28.86 10.25,54 12.1,68.891 h 122 l -8.39,-46.563 h 1.87 c 34.45,31.672 81.93,57.742 135.96,57.742 94.05,0 156.44,-58.652 156.44,-153.64 0,-36.328 -9.31,-74.512 -15.84,-104.309 L 4898.3,211.73 h -124.78 l 46.56,226.282 c 6.53,32.578 13.98,65.179 13.98,100.578 0,40.051 -27.94,67.031 -67.98,67.031 -86.62,0 -118.27,-80.992 -134.1,-152.691 l -51.22,-241.2 h -124.79 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5165.55,691.301 44.69,-356.641 h 1.86 L 5403,691.301 h 136.89 L 5214.9,139.102 C 5176.72,73.9219 5129.22,5 5024.01,5 c -31.67,0 -62.4,4.66016 -93.13,13.0391 l 27.94,94.9999 c 14.89,-5.609 29.81,-11.187 54.94,-11.187 37.25,0 65.19,18.636 108.94,86.597 l -84.73,502.852 h 127.58",
    style: {
      fill: "#1c4e9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5165.55,691.301 44.69,-356.641 h 1.86 L 5403,691.301 h 136.89 L 5214.9,139.102 C 5176.72,73.9219 5129.22,5 5024.01,5 c -31.67,0 -62.4,4.66016 -93.13,13.0391 l 27.94,94.9999 c 14.89,-5.609 29.81,-11.187 54.94,-11.187 37.25,0 65.19,18.636 108.94,86.597 l -84.73,502.852 z",
    style: {
      fill: "none",
      stroke: "#1c4e9d",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path108"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4270a0c391053c098cb614d54662ef91.svg";
export { ForwardRef as ReactComponent };